// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderAuth_root__WTLq_","login":"HeaderAuth_login__qEy7c","register":"HeaderAuth_register__elwF6","user":"HeaderAuth_user__QLIwd","compact":"HeaderAuth_compact__qGyWo"};